import React, { PureComponent } from 'react'
import { reaction } from 'mobx'
import i18n from 'i18next'

import PanelHeader from '../../../../UniformComponents/PanelHeader'
import MergeFields from '../../../../utils/MergeFields'
import Badge from '../../../../UniformComponents/Badge'

const StatusLabels = ({ isMaxbi, stats }) => {
    const { complete, drop, screen } = stats

    if (isMaxbi) {
        return (
            <Badge
                type={complete ? 'success' : 'error'}
                cssClass="rounded"
                label={i18n.t(complete ? 'completed' : 'notStarted')}
                icon={complete ? 'fal fa-circle-check' : 'fal fa-ban'}
            />
        )
    }

    return (
        <div style={{ display: 'flex', gap: '10px' }}>
            <Badge
                type="success"
                cssClass="rounded"
                label={complete}
                icon="fa-regular fa-check"
            />
            <Badge
                type="warning"
                cssClass="rounded"
                label={drop}
                icon="fa-regular fa-arrow-down"
            />
            <Badge
                type="error"
                cssClass="rounded"
                label={screen}
                icon="fa-regular fa-ban"
            />
        </div>
    )
}

class ReportPageHeader extends PureComponent {
    constructor(props) {
        super(props)
        const { reportStore, isMaxbi } = props

        const data = this.getReportData(isMaxbi)
        this.state = {
            complete: data.complete,
            screen: data.screen,
            drop: data.drop,
        }

        reaction(
            () => reportStore.reportDataFetched,
            () => {
                const newData = this.getReportData(isMaxbi)
                this.setState({
                    complete: newData.complete,
                    screen: newData.screen,
                    drop: newData.drop,
                })
            },
        )
    }

    getReportData = (isMaxbi) => {
        const { reportStore, pageIndex, page } = this.props
        const { complete } = isMaxbi
            ? reportStore.v2ReportStats.stats.details
            : reportStore.reportData.stats.details
        return {
            complete: isMaxbi ? complete[page.id] : complete[pageIndex],
            screen: reportStore.reportData.stats.details.screen[pageIndex],
            drop: reportStore.reportData.stats.details.drop[pageIndex],
        }
    }

    render() {
        const {
            page,
            isOpen,
            toggleOpen,
            reportStore,
            pageIndex,
            isMaxbi,
        } = this.props
        const { complete, screen, drop } = this.state
        const chevron = isOpen ? 'up' : 'down'

        return (
            <PanelHeader>
                <div style={{ display: 'flex', padding: '15px', alignItems: 'center' }}>
                    <div style={{ display: 'flex', flex: 1, gap: '10px' }}>
                        <i
                            onClick={toggleOpen}
                            className={`fa-thin fa-chevron-${chevron}`}
                            style={{
                                color: '#715AFF',
                                backgroundColor: '#F7F5FF',
                                borderRadius: '3px',
                                padding: '10px',
                                cursor: 'pointer',
                            }}
                        />
                        <div style={{display: 'flex', gap: '15px', alignItems: 'center' }}>
                            <h4
                                style={{
                                    color: '#102E4A',
                                    margin: '0px',
                                }}
                            >
                                Page
                                {' '}
                                {(pageIndex + 1)}
                            </h4>
                            <span style={{ fontSize: '16px', fontWeight: 500 }}>
                                {
                                    MergeFields.replace(
                                        page.title,
                                        reportStore.locale,
                                        reportStore.mergeFields,
                                    )
                                }
                            </span>
                        </div>
                    </div>

                    <StatusLabels stats={{ complete, screen, drop }} isMaxbi={isMaxbi} />
                </div>
            </PanelHeader>
        )
    }
}

export default ReportPageHeader
